import React, { PropTypes } from 'react'
import CSSModules from 'react-css-modules'

import GridHeader from './grid-header'
import GridContent from './grid-content'
import GridLeftHeader from './grid-left-header'

import styles from './grid.css'

const Grid = ({
  cellWidth,
  dates,
  gridRecomputeTime,
  headerHeight,
  height,
  leftHeaderCellWidth,
  onScroll,
  calculateRowHeight,
  scrollLeft,
  scrollTop,
  times,
  width,
}) => (
  <div styleName="grid">
    <GridHeader
      cellWidth={cellWidth}
      cornerWidth={leftHeaderCellWidth}
      height={headerHeight}
      items={times}
      scrollLeft={scrollLeft}
      width={width}
    />
    <div styleName="grid-body">
      <GridLeftHeader
        gridRecomputeTime={gridRecomputeTime}
        height={height - headerHeight}
        items={dates}
        calculateRowHeight={calculateRowHeight}
        scrollTop={scrollTop}
        width={leftHeaderCellWidth}
      />
      <GridContent
        cellWidth={cellWidth}
        columnCount={times.count() + 1}
        dates={dates}
        gridRecomputeTime={gridRecomputeTime}
        height={height - headerHeight}
        onScroll={onScroll}
        rowCount={dates.count()}
        calculateRowHeight={calculateRowHeight}
        times={times}
        width={width - leftHeaderCellWidth}
      />
    </div>
  </div>
)

Grid.propTypes = {
  cellWidth: PropTypes.number.isRequired,
  dates: PropTypes.object.isRequired,
  gridRecomputeTime: PropTypes.number.isRequired,
  headerHeight: PropTypes.number.isRequired,
  height: PropTypes.number.isRequired,
  leftHeaderCellWidth: PropTypes.number.isRequired,
  onScroll: PropTypes.func.isRequired,
  calculateRowHeight: PropTypes.func.isRequired,
  scrollLeft: PropTypes.number.isRequired,
  scrollTop: PropTypes.number.isRequired,
  times: PropTypes.object.isRequired,
  width: PropTypes.number.isRequired,
}

export default CSSModules(Grid, styles)



/** WEBPACK FOOTER **
 ** ./src/components/grid/grid.js
 **/